import PaymentHistoryFilters from './PaymentHistoryFilters';

export default PaymentHistoryFilters;
